import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '../service/session.service';
import { CurrencyPipe } from '@angular/common';

// Overrides the angular currency pipe to format using the configured currency of the active storefront
@Pipe({
  name: 'currency'
})
export class StorefrontCurrencyPipe implements PipeTransform {

  constructor(private session: SessionService, private currency: CurrencyPipe) { }

  transform(value: any, ...args: any[]) {
    const currencyCode = this.session.currencyCode || 'USD';
    return this.currency.transform(value, currencyCode);
  }
}
